var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgViewOn = function SvgViewOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.234 10.286l.16.171a2.286 2.286 0 0 1 0 3.086l-.16.171-.014.016c-1.295 1.398-3.69 3.984-7.22 3.984s-5.925-2.586-7.22-3.984l-.014-.016-.16-.171a2.285 2.285 0 0 1 0-3.086l.16-.171.014-.016C6.075 8.872 8.47 6.286 12 6.286s5.925 2.586 7.22 3.984l.014.016zM12 15.429c2.286 0 4.034-1.635 5.52-3.235a.286.286 0 0 0 0-.388C16.011 10.183 14.286 8.57 12 8.57c-2.286 0-4.011 1.612-5.52 3.235a.286.286 0 0 0 0 .388c1.486 1.6 3.234 3.235 5.52 3.235zM14.286 12a2.286 2.286 0 1 1-4.572 0 2.286 2.286 0 0 1 4.572 0z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgViewOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "view-on.9c3f88b72c6ae42c8bd1b2031b91232c.svg";